// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { ProItemDesignApi } from '../types/pro-item-design.types';
import { proItemDesignHttpApi } from './pro-item-design.api';
import { proItemDesignMockApi } from './pro-item-design.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const proItemDesignApi: ProItemDesignApi = useMock
  ? proItemDesignMockApi
  : proItemDesignHttpApi;
